import { getMcAppFromBaseProps } from "../lib/baseProps";
import { IBaseProps, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const createConcessionsMcApp = ({
  name,
  ...props
}: IBaseProps): IMcAppType[] => {
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_DIGISHIFT`,
      digishiftPath: "/manage/concessions",
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/concessions",
      intent: name,
    }),
  ];
};

const concessionsApps: IBaseProps[] = [
  {
    name: "concessions",
    path: "/my-account/concessions",
    subPath: "",
    description: "View Concessions",
    navFlow: NavFlow.FOCUS,
    title: "Concessions",
    parent: Tab.MORE,
  },
];

export const concessions: IMcAppType[] = concessionsApps.flatMap((app) =>
  createConcessionsMcApp(app)
);
